import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import FileUploadOutlined from '@mui/icons-material/FileUploadOutlined';
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { translations } from '../../../utils/staticContent';
import { useState } from 'react';
import Button from '@mui/material/Button';
import { FileApi } from '../../../network';
import ApiErrorHandler from '../../../utils/ApiErrorHandler';

type Props = {
    setError: React.Dispatch<React.SetStateAction<string>>;
    fileId: string;
    setFileId: React.Dispatch<React.SetStateAction<string>>;
};

export default function ImageUploadForm({ setError, fileId, setFileId }: Props) {
    const [file, setFile] = useState<File | null>(null);
    const [url, setUrl] = useState('');
    return (
        <Grid item container xs={12} sm={12} rowSpacing={2} columnSpacing={{ xs: 1, sm: 2 }}>
            <Grid item xs={12} sm={6} container>
                {fileId && (
                    <Grid item xs={12} sm={12}>
                        <Typography
                            component="span"
                            color="green"
                            sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                        >
                            <CheckCircleOutline />
                            {translations.imageUploaded}
                        </Typography>
                    </Grid>
                )}
                {url && (
                    <Grid item xs={12} sm={12}>
                        <img src={url} />
                    </Grid>
                )}
            </Grid>
            <Grid item xs={12} sm={6} container>
                <Grid item xs={12} sm={12}>
                    <TextField
                        type="text"
                        fullWidth
                        id="file"
                        label={translations.file}
                        autoFocus
                        value={file?.name}
                        InputLabelProps={{ shrink: true }}
                        disabled
                        InputProps={{
                            endAdornment: (
                                <IconButton component="label">
                                    <FileUploadOutlined />
                                    <input
                                        style={{ display: 'none' }}
                                        type="file"
                                        hidden
                                        onChange={(e) => {
                                            const files = e.currentTarget.files;
                                            if (files) {
                                                setFile(files[0]);
                                            }
                                        }}
                                        name="file"
                                        value=""
                                    />
                                </IconButton>
                            ),
                        }}
                    />
                    <Grid item xs={12} sm={12}>
                        <Button
                            fullWidth
                            variant="contained"
                            disabled={!file}
                            sx={{ mt: 2 }}
                            onClick={async () => {
                                if (file) {
                                    try {
                                        const response =
                                            await FileApi.getUploadUrlApiV1FilesSignedUrlGet();

                                        const res = await fetch(response.url, {
                                            method: 'PUT',
                                            headers: {
                                                'Content-Type': file.type,
                                            },
                                            body: file,
                                        });
                                        if (!res.ok) {
                                            setError(res.statusText);
                                            return;
                                        }
                                        setFileId(response.fileId);
                                    } catch (e) {
                                        const error = ApiErrorHandler(e);
                                        setError(error);
                                    }
                                }
                            }}
                        >
                            {translations.uploadNewImage}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}
